import { useState } from "react";
import ShowSuccess from "../Components/show-success";
import Accordion from "../CRP/components/Accordion";
import './registration.css'
import { BsWhatsapp } from "react-icons/bs";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";



const faqs = [
    {
        question: "What happens after I submit the form?",
        answer: `Our team will review your details and get in touch within 24–48 hours to understand your offerings and list your venue.`,
    },
    {
        question: "How do I start getting bookings through PartyWitty?",
        answer: (<p>Once your profile is verified, you’ll start receiving party inquiries. You can <strong>submit your offer</strong> for each inquiry, and the customer chooses the best deal.</p>)
    },
    {
        question: "Is there any registration fee to join PartyWitty?",
        answer: "We offer both free and paid plans. Our team will guide you on which plan fits your business best.",
    },
    {
        question: " What kind of bookings can I expect?",
        answer: " We get group parties, table bookings, and corporate events. You’ll receive leads based on your venue type and location.",
    },
    {
        question: "How can I update or change my venue details later?",
        answer: "Once onboarded, you’ll get a dashboard or support access to update your profile, images, and offers.",
    },
    {
        question: "Will I be promoted on PartyWitty’s social media or website?",
        answer: "Yes! Our paid partners get featured listings, social media promotions, and early access to offers. ",
    },

];


const RegistrationLoginFormSubmitted = () => {


    const [openIndex, setOpenIndex] = useState(null);
    const handleFAQtoggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };




    return (
        <>
            <div className="registration-business-form-submit-section-page">
                <ShowSuccess
                    message='Registration form submitted successfully!   Let’s Make Your Venue the Go-To Party Spot!'
                    thanksyouMessage='Thanks for partnering with PartyWitty. We’ll connect within 48 hours — next stop: more visibility, more bookings, and packed weekends!'
                />
                <div className="rbfssp-accordion-section">
                    <div className='event-detail-page-design-content-section-faq-heading' onClick={() => { handleFAQtoggle(1) }}>
                        <h2>Frequently asked questions</h2>
                        {openIndex === 1 ? <IoIosArrowUp /> : <IoIosArrowDown />}
                    </div>

                    {openIndex === 1 && (
                        <Accordion faqs={faqs} />
                    )}
                </div>
                <a href="https://wa.me/+918299619469" target="_blank">
                    <div className="rbfssp-whatsapp-section">
                        <BsWhatsapp className="rbfssp-whatsapp-icon" />
                    </div>
                </a>
            </div>

        </>
    )
}

export default RegistrationLoginFormSubmitted;